import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useLayoutEffect } from "react";
import { z } from "zod";
import { toast } from "sonner";
import { signInWithCustomToken } from "firebase/auth";
import { auth } from "@/lib/firebase";
import { auth as firebaseAuthHandler } from "@/lib/auth";
import { SignedOut, SignIn, useAuth } from "@clerk/clerk-react";

export const Route = createFileRoute("/login")({
  component: () => (
    <div className="flex h-screen w-full flex-col items-center justify-center">
      <SignInUI />
    </div>
  ),
  validateSearch: (search) =>
    z
      .object({
        redirect: z.string().optional(),
      })
      .parse(search),
});

function SignInUI() {
  const { isLoaded, getToken, isSignedIn } = useAuth();
  const { redirect } = Route.useSearch();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    if (!isLoaded) return;
    if (isSignedIn) {
      toast.success("Signed in");
      const loginToFirebase = async () => {
        const user = await firebaseAuthHandler.getUser();
        if (!user) {
          const token = await getToken({ template: "integration_firebase" });
          if (!token) throw new Error("Error generating clerk token");

          await signInWithCustomToken(auth, token);
        }
        await navigate({ to: redirect || "/dashboard" });
      };
      loginToFirebase();
    } else {
      navigate({ to: redirect || "/dashboard" });
    }
  }, [isLoaded, isSignedIn]);

  return (
    <>
      <SignedOut>
        <SignIn />
      </SignedOut>
    </>
  );
}
